<template>
    <div>
        <!-----------------------------------
        |          VISTA PRINCIPAL          |
        ------------------------------------>
        <v-row>
            <v-col class="d-flex justify-end">
                <CommonButtons v-if="componenteEvento.agregar_submodulo" @click="addItem" iconBut="fas fa-plus"
                    textButton="Agregar escala de evaluación" normalButton />
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="EscalaEvaluacionHeaders" :items="Datos">
                    <template v-slot>
                        <!-- <pre>{{ Datos }}</pre> -->
                        <v-row>
                            <v-col cols="12" md="3" sm="3">
                                <AutocompleteComp @change="getAllPeriodosAnoLectivo(filtros.ano_lectivo)"
                                    textLabel="Año lectivo" :items="anios_lectivos" item-value="id"
                                    item-text="nom_anolectivo" v-model="filtros.ano_lectivo" />
                            </v-col>
                            <v-col cols="12" md="3" sm="3">
                                <AutocompleteComp @change="getAllEscalasEvaluativas('periodo')" textLabel="Periodo"
                                    :items="periodos" item-value="id" item-text="nombre" v-model="periodoConfig"
                                    :isDisable="disablePeriodo" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:Estado="{ item }">
                        <v-chip v-if="item.estado === 1" small class="color_activo">
                            Asignado
                        </v-chip>
                        <v-chip v-if="item.estado === 0" small class="mr-2 color_inactivo">
                            No asignado
                        </v-chip>
                    </template>
                    <template v-slot:action_ver="{ item }">
                        <CommonButtons v-if="componenteEvento.visualizar_submodulo"
                            @click="getAllConfiguraciones(item, 'visualizar')" verButton tooltipText="Ver escala" />
                    </template>
                    <template v-slot:action_editar="{ item }">
                        <CommonButtons v-if="componenteEvento.editar_submodulo"
                            @click="getAllConfiguraciones(item, 'editar')" editButton tooltipText="Editar escala" />
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>

        <!---------------------------------------------------
        |          MODAL AGREGAR ESCALA EVALUATIVA          |
        ---------------------------------------------------->
        <v-form ref="formDatos" lazy-validation>
            <CommonDialog v-model="dialog" :title="formTitle" maxWidth="800" @close-modal="closeModal">
                <template v-slot:body>
                    <v-row>
                        <v-col cols="6">
                            <AutocompleteComp @change="getAllNivelesperiodo(filtros.periodo_escala)" textLabel="Periodo"
                                :items="Periodos_activos" item-value="id" item-text="nombre"
                                v-model="filtros.periodo_escala" :readonly="bloquearCampo" />
                            <!-- <v-autocomplete v-model="filtros.periodo_escala" label="Periodo b" :items="Periodos_activos" item-value="id"
                                item-text="nombre" :readonly="bloquearCampo" 
                                multiple return-object>
                            </v-autocomplete> -->
                            <!-- 
                            <v-select v-model="selectedIdPerdiodo" :items="Periodos_activos" label="Periodo"
                                @change="getAllNivelesperiodo($event)" item-text="nombre" item-value="id" multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item class="ma-0" @mousedown.prevent @click="toggle">
                                        <v-list-item-action>
                                            <v-icon size="30">
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title> 
                                                <b>Seleccionar Todos</b>                                                
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                </template>
                            </v-select> -->
                        </v-col>

                        <v-col class="d-flex flex-row-reverse" v-if="evento === 'agregar' || evento === 'editar'"
                            style="margin-top:15px">
                            <CommonButtons @click="addValorEvaluativo" textButton="Asignar valor de
                                evaluación" normalButton />
                        </v-col>
                    </v-row>
                    <ComundataTablecomp :headers="headers_escalaEval" :items="info">
                        <template v-slot:escala="{ item }">
                            <v-chip v-if="item.tipo_escala === 'L'" color="#6abf69" dark small class="font-weight-black">
                                Literal
                            </v-chip>
                            <v-chip v-if="item.tipo_escala === 'N'" color="#0277bd" dark small class="font-weight-black">
                                Numérica
                            </v-chip>
                        </template>
                        <template v-slot:action_editar="{ item }" v-if="evento === 'agregar' || evento === 'editar'">
                            <CommonButtons v-if="componenteEvento.editar_submodulo"
                                @click="editarConfiguracion(item, 'editar')" editButton tooltipText="Editar" />
                        </template>
                        <template v-slot:action_borrar="{ item }" v-if="evento === 'agregar' || evento === 'editar'">
                            <CommonButtons v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)"
                                deleteButton tooltipText="Eliminar" />
                        </template>
                    </ComundataTablecomp>
                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <CommonButtons v-if="evento == 'editar'" @click="saveItem" textButton="Guardar cambios"
                        iconBut="fas fa-save" normalButton>
                    </CommonButtons>
                    <CommonButtons v-if="evento == 'agregar'" @click="saveItem" textButton='Guardar' iconBut="fas fa-save"
                        normalButton>
                    </CommonButtons>
                </template>
            </CommonDialog>
        </v-form>

        <!-----------------------------------------------------------
        |          MODAL DE ASIGNACIÓN DE VALOR EVALUACION          |
        ------------------------------------------------------------>
        <v-form ref="formData" lazy-validation>
            <CommonDialog v-model="dialog2" maxWidth="450" :title="formTitle2" @close-modal="dialog2 = false">
                <template v-slot:body>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" class="py-0" v-if="evento2 == 'agregar'">
                                <v-select v-model="nivel" :items="Niveles" item-value="Niveles" item-text="desc_nivel"
                                    label="Nivel" @change="getAllGradosNieveles(Niveles)"
                                    :rules="validationRules.validateCampoList" return-object :readonly="false"></v-select>
                                <!-- bloquearCampo2 -- nivel  Niveles multiple-->
                            </v-col>

                            <v-col cols="12" class="py-0" v-if="evento2 == 'editar'">
                                <v-text-field v-model="nivel_descripcion" label="Nivel" readonly></v-text-field>
                            </v-col>

                            <v-col cols="12" class="py-0" v-if="evento2 == 'agregar'">
                                <v-select v-model="grado" :items="Grados" item-value="Grados" item-text="desc_grado"
                                    label="Grados" multiple :rules="validationRules.validateEmptyArray" return-object
                                    :readonly="bloquearCampo2"></v-select>
                            </v-col>

                            <v-col cols="12" class="py-0" v-if="evento2 == 'editar'">
                                <v-text-field v-model="grado_descripcion" label="Grado" readonly></v-text-field>
                            </v-col>

                            <v-col cols="12" class="py-0">
                                <v-select label="Tipo de escala de evaluación" :items="tipoNota" item-value="tipo"
                                    item-text="nom_tipoNota" v-model="tipoEscala"
                                    :rules="validationRules.validateCampoList">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                </template>

                <template v-slot:actions>

                    <v-spacer></v-spacer>
                    <CommonButtons v-if="evento2 == 'editar'" @click="editconfiguracion" textButton="Guardar cambios"
                        iconBut="fas fa-save" normalButton>

                    </CommonButtons>
                    <CommonButtons v-if="evento2 == 'agregar'" @click="addConfiguracion" textButton='Guardar'
                        iconBut="fas fa-save" normalButton>

                    </CommonButtons>
                </template>

            </CommonDialog>

        </v-form>

        <!-----------------------------------------------
        |          MODAL DE ELIMINAR REGISTROS          |
        ------------------------------------------------>
        <CommonDialog Deletedialog v-model="dialog_delete" @close-modal="dialog_delete = false"
            titleWindow="Eliminar valor de evaluación" @delete-item="deleteItem" @cancel-item="dialog_delete = false">
            <template v-slot:body>
                ¿Está seguro de eliminar este registro?
            </template>
        </CommonDialog>
    </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import CommonDialog from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import CommonButtons from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { validationRules } from '../../../../helpers/validatorHelpers';
import { EscalaEvaluacionHeaders } from '../../../../helpers/headersTable';

export default {
    name: 'formEscalaEval',
    props: ['parametros', 'anios_lectivos'],
    components: {
        CommonDialog,
        CommonButtons,
        AutocompleteComp,
        ComundataTablecomp
    },
    data: () => ({
        paramComponente: { 'id_submodulo': 86, "id_modulo": 5 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        EscalaEvaluacionHeaders,
        //validaciones de formulario
        filtros: {
            ano_lectivo: null,
            periodo_escala: null,
        },

        periodos: [],
        periodoConfig: null,
        disablePeriodo: true,
        Datos: [],
        // MODAL AGREGAR-EDITAR ESCALA EVALUATIVA
        evento: null,
        titulo: 'Escala de evaluación',
        dialog: false,
        formTitle: '',
        bloquearCampo: false,
        Periodos_activos: [],
        nivel: [],
        info: [],
        configuraciones: [],

        headers_escalaEval: [],
        // tabla de registros de configuracion
        headers_valorEvaluativo: [
            { text: 'TIPO DE ESCALA DE EVALUACIÓN', value: 'escala', class: 'header_datatable' },
            { text: 'NIVEL', value: 'desc_nivel', sortable: false, align: 'center', class: 'header_datatable' },
            { text: 'GRADO', value: 'desc_grado', sortable: false, align: 'center', class: 'header_datatable' },
            { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
            { text: 'ELIMINAR', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
        ],
        headers_valorEvaluativoVer: [
            { text: 'TIPO DE ESCALA DE EVALUACIÓN', value: 'escala', class: 'header_datatable' },
            { text: 'NIVEL', value: 'desc_nivel', sortable: false, align: 'center', class: 'header_datatable' },
            { text: 'GRADO', value: 'desc_grado', sortable: false, align: 'center', class: 'header_datatable' },
        ],
        // MODAL ASIGNAR VALOR EVALUATIVO
        evento2: null,
        dialog2: false,
        formTitle2: '',
        bloquearCampo2: false,
        titulo2: 'Asignar valor de evaluación',
        titulo3: 'Editar valor de evaluación',

        dataform: [],
        grado: [],
        tipoEscala: '',
        nivel_descripcion: '',
        grado_descripcion: '',

        Niveles: [],
        Grados: [],
        tipoNota: [
            { "tipo": "L", "nom_tipoNota": "Literal" },
            // { "tipo": "N", "nom_tipoNota": "Numérica" },
        ],
        arrayDatos: {
            data: []
        },
        elIndex: null,
        // MODAL ELIMINAR
        dialog_delete: false,
        desc_delete: null,
        id_delete: null,
        ///////////////////////////////
        selectedIdPerdiodo: [],
    }),
    computed: {
        ...mapGetters('login', ['componenteEvento']),
        validationRules() {
            return validationRules
        },

        // selectAllPeriodos() {
        //     return this.selectedIdPerdiodo.length == this.Periodos_activos.length
        // },
        // selectSomePeriodos() {
        //     return this.selectedIdPerdiodo.length > 0 && !this.selectAllPeriodos
        // },
        // icon() {
        //     if (this.selectAllPeriodos) return 'mdi-close-box'
        //     if (this.selectSomePeriodos) return 'mdi-minus-box'
        //     return 'mdi-checkbox-blank-outline'
        // },
    },
    created() {
        this.actualizarParamentro();
        this.getAllEscalasEvaluativas('vista')
    },
    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

        // toggle() {
        //     this.$nextTick(() => {
        //         if (this.selectAllPeriodos) {
        //             this.selectedIdPerdiodo = []
        //         } else {
        //             this.selectedIdPerdiodo = this.Periodos_activos.map(per => per.id);
        //             this.getAllNivelesperiodo(this.selectedIdPerdiodo);
        //             // this.selectedIdPerdiodo = this.Periodos_activos.slice()
        //         }
        //     })
        // },


        ////////// metodo que carga todas las configuraciones
        async getAllEscalasEvaluativas(accion) {
            try {
                let params = {}

                if (accion == 'vista') {
                    params = {
                        "id_colegio": sessionStorage.id_colegio,
                        "id_ano_lectivo": sessionStorage.id_ano_lectivo,
                    }
                }

                else {
                    params = {
                        "id_colegio": sessionStorage.id_colegio,
                        "id_ano_lectivo": sessionStorage.id_ano_lectivo,
                        "id_periodo": this.periodoConfig
                    }
                }

                let response = await axios.post("/administrativo/confEscalaEvaluativa/getConfEscalaEvaluativaAll/", params);
                this.Datos = response.data

            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }
        },
        /////////////////////////////////////////////////////////////



        ////////////  traer los periodos del año lectivo seleccionado /////////
        async getAllPeriodosAnoLectivo(id) {
            let params = {
                "id_colegio": sessionStorage.id_colegio,
                "id_anio_lectivo": id
            }

            try {
                //let response = await axios.post("/administrativo/periodo/list/",params)
                let response = await axios.post('/administrativo/confEscalaEvaluativa/getPeriodo/', params)
                this.periodos = response.data


                if (this.periodos.length > 0) {
                    this.disablePeriodo = false
                }
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }
        },
        //////////////////////////////////////////////////////////////////





        //----------- validar modal  Escala evaluativa --------------
        async addItem() {
            this.formTitle = "Crear " + this.titulo
            // this.filtros.periodo_escala = '' //POSIBLE CORRECCION
            this.filtros.periodo_escala = [];
            this.dialog = true
            this.evento = 'agregar'
            this.bloquearCampo = false
            this.headers_escalaEval = this.headers_valorEvaluativo

            this.getAllPeriodosActivos()
        },
        ////////////////////////////////////////////////////////




        ///////////  Traer periodos de año lectivo activos  //////////////
        async getAllPeriodosActivos() {
            let params = {
                "id_colegio": sessionStorage.id_colegio,
                "id_ano_lectivo": sessionStorage.id_ano_lectivo
            }

            try {
                let response = await axios.post('/administrativo/confEscalaEvaluativa/getPeriodoActivos/', params);
                this.Periodos_activos = response.data;

            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }
        },
        /** 
         ________________________________________________________
        |          MÉTODO OBTENER NIVELES DEL PERDIODO         */
        async getAllNivelesperiodo(id_nivel_array) {

            if (id_nivel_array.length == 0) {
                this.setEnviarMens({
                    tipo: "W",
                    mensaje: "Debe seleccionar al menos un periodo",
                    tiempo: null,
                });
                return;
            }

            try {
                let response = await axios.get("/administrativo/nivel/getNivelArrayPeriodo/" + id_nivel_array)
                // let response = await axios.get("/administrativo/nivel/getNivelPeriodo/" + id)
                this.Niveles = response.data;

                this.getAllGradosNieveles(this.Niveles)

                this.limpiarForm()
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }
        },
        /** 
         _______________________________________________
        |          MÉTODO LIMPIAR FORMULARIO          */
        async limpiarForm() {
            this.dataForm = {
                id_colegio: sessionStorage.id_colegio,
                id_ano_lectivo: sessionStorage.id_ano_lectivo,
                id_us_ing: sessionStorage.id,
                nivel: [], grado: [], tipoEscala: '',
            }

            this.Grados = []
            this.grado = []
            this.tipoEscala = ''

            this.$refs.formData.resetValidation()
        },



        //----------- validar modal  Escala evaluativa --------------
        addValorEvaluativo() {
            // this.filtros.periodo_escala = this.selectedIdPerdiodo;
            if (this.filtros.periodo_escala == '') {
                // if (this.filtros.periodo_escala.length == 0) {
                this.setEnviarMens({ tipo: "W", mensaje: 'Debe seleccionar un periodo', tiempo: null })
            } else {
                this.formTitle2 = this.titulo2
                this.dialog2 = true
                this.evento2 = 'agregar'
                this.bloquearCampo2 = false
            }
        },
        /////////  Grados segun Nivel  ////////////////////
        async getAllGradosNieveles(item) {
            try {
                let params = {
                    "id_ano_lectivo": sessionStorage.id_ano_lectivo,
                    "id_colegio": sessionStorage.id_colegio,
                    "id_nivel": item[0].id,
                    "id_periodo": this.filtros.periodo_escala
                }

                let response = await axios.post("/administrativo/confEscalaEvaluativa/getGradoNoConfEscalaEvaluativa/", params)
                this.Grados = response.data

            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /////////  metodo que agrega la configuracional array previo
        addConfiguracion() {
            if (this.$refs.formData.validate()) {

                var anio = sessionStorage.id_ano_lectivo
                var colegio = sessionStorage.id_colegio

                for (var i = 0; i < this.grado.length; i++) {

                    //verifica si existe un grado con escala evaluativa
                    let checker = this.info.find(inf => inf.id_grado == this.grado[i].id);
                    if(checker) continue
                    
                    this.info.push({
                        'id_ano_lectivo': anio,
                        'id_colegio': colegio,
                        'tipo_escala': this.tipoEscala,
                        'id_periodo': this.filtros.periodo_escala,
                        'desc_nivel': this.nivel.desc_nivel,
                        'id_nivel': this.nivel.id,
                        'desc_grado': this.grado[i].desc_grado,
                        'id_grado': this.grado[i].id,
                        'id_us_ing': sessionStorage.id
                    })
                }
                
                this.arrayDatos.data = this.info
                this.dialog2 = false

                this.grado = []
                this.tipoEscala = ''
                this.getAllGradosNieveles(this.Niveles)
                this.setEnviarMens({ tipo: "S", mensaje: `Información creada con éxito`, tiempo: null })
            }

            else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe completar todos los campos requeridos`, tiempo: null })
            }
        },
        //////////////////////////////////////////



        ////////////   Guardar Configuraciones /////////////
        async saveItem() {


            try {
                const filtros = {...this.arrayDatos, id_periodo: this.filtros.periodo_escala};
                
                if (this.evento == "agregar") {
                    if (!this.arrayDatos.data.length) return this.setEnviarMens({ tipo: "W", mensaje: `Debe asignar un valor de evaluación.`, tiempo: null });

                    let res = await axios.post("/administrativo/confEscalaEvaluativa/addArrayConfEscalaEvaluativa/", filtros);
                    // let res = await axios.post("/administrativo/confEscalaEvaluativa/addConfEscalaEvaluativa/", this.arrayDatos)

                    if (res.data.messageT == "S") {
                        this.dialog = false
                        this.evento = null
                        this.periodoConfig ? await this.getAllEscalasEvaluativas() : await this.getAllEscalasEvaluativas('vista')
                        // this.getAllEscalasEvaluativas('vista')
                        this.info = []
                        this.arrayDatos.data = []
                        this.Periodos_activos = []
                        this.limpiarForm()
                    }

                    this.setEnviarMens({ tipo: res.data.messageT, mensaje: `${res.data.message}`, tiempo: null })
                }


                if (this.evento == "editar") {
                    for (var i = 0; i < this.info.length; i++) {
                        this.info[i].id_us_ing = sessionStorage.id
                        this.info[i].id_colegio = sessionStorage.id_colegio
                    }
                    this.arrayDatos.data = this.info
                    const filtros = {...this.arrayDatos, id_periodo: this.filtros.periodo_escala}

                    let res = await axios.post("/administrativo/confEscalaEvaluativa/addArrayConfEscalaEvaluativa/", filtros)
                    if (res.data.messageT == "S") {
                        this.dialog = false
                        this.evento = null
                        this.periodoConfig ? await this.getAllEscalasEvaluativas() : await this.getAllEscalasEvaluativas('vista')
                        // this.getAllEscalasEvaluativas('vista')
                        this.info = []
                        this.arrayDatos.data = []
                        this.Periodos_activos = []
                        this.limpiarForm()

                    }

                    this.setEnviarMens({ tipo: res.data.messageT, mensaje: `¡Información actualizada con éxito!`, tiempo: null })
                }
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }

        },
        //////////////////////////////////////////////////////////////





        /////  metodo que carga las configuraciones validando si
        //// son para validar o editar
        async getAllConfiguraciones(item, accion) {

            var id = item.id

            try {
                await this.getAllPeriodosActivos()

                this.filtros.periodo_escala = id;
                let response = await axios.get("/administrativo/confEscalaEvaluativa/" + id)
                this.configuraciones = response.data
                this.info = this.configuraciones

                this.dialog = true
                this.bloquearCampo = true

                this.PeriodoEditar = item.nombre_periodo
                // this.filtros.periodo_escala = item.id //CORRECCION
                // this.filtros.periodo_escala = item.id

                if (accion === 'visualizar') {
                    this.formTitle = this.titulo
                    this.evento = 'visualizar'
                    this.headers_escalaEval = this.headers_valorEvaluativoVer
                    //this.modal_configuraciones = true
                }

                if (accion === 'editar') {
                    this.getAllNivelesperiodo(id);
                    this.formTitle = "Editar " + this.titulo
                    this.evento = 'editar'
                    this.headers_escalaEval = this.headers_valorEvaluativo

                    //this.info = this.configuraciones
                    //this.dialog = true
                    //this.PeriodoEditar = item.nombre_periodo
                    //this.idPeriodoEditar = item.id
                }
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

            }

        },
        ////////////////////////////////////////////////////////////


        closeModal() {
            this.dialog = false
            this.info = []
            this.arrayDatos.data = []
            this.Periodos_activos = []
            this.limpiarForm()
        },


        // activa la modal para confirmar el eliminar el registro
        deleteConfirm(items) {
            this.dialog_delete = true
            this.id_delete = items.id || (items.desc_grado + items.id_grado)
        },



        //------------ELIMINAR Registro -------------
        async deleteItem() {
            // const index = this.info.indexOf(this.id_delete)  // wilmer @#!&*
            // this.info.splice(index, 1)


            this.info = this.info.filter(inf => (inf.id || inf.desc_grado + inf.id_grado) != this.id_delete)

            this.arrayDatos.data = this.info

            this.dialog_delete = false
        },



        editarConfiguracion(item) {

            /* this.tipoEscala = item.tipo_escala
            this.Niveles.desc_nivel = item.desc_nivel
            this.modal_editar = true
            this.elIndex = this.info.indexOf(item) */

            this.elIndex = this.info.indexOf(item)

            this.formTitle2 = this.titulo3
            this.dialog2 = true
            this.evento2 = 'editar'
            this.bloquearCampo2 = true

            this.tipoEscala = item.tipo_escala
            this.nivel_descripcion = item.desc_nivel
            this.grado_descripcion = item.desc_grado

        },
        ///////////////////////////////////////////////////////



        /////  metodo para editar una configuracion ya agregada
        editconfiguracion() {
            this.info[this.elIndex].tipo_escala = this.tipoEscala
            /* this.modal_editar = false
            this.escala  = '' */

            this.dialog2 = false
            this.nivel_descripcion = ''
            this.grado_descripcion = ''
            this.setEnviarMens({ tipo: "S", mensaje: `Información editada con éxito`, tiempo: null })
        },

    },
}
</script>

